import * as yup from 'yup';
import { PersonalIdentityType } from './PersonalIdentityType';
import { PersonalIdentity } from './PersonalIdentity';

export const PersonalIdentitySchema: yup.SchemaOf<PersonalIdentity> = yup.object({
  identityType: yup.mixed<PersonalIdentityType>().oneOf([PersonalIdentityType.CustomerId, PersonalIdentityType.PassportNumber]).required(),

  customerId: yup
    .string()
    .default('')
    .label('National ID number')
    .when('identityType', {
      is: PersonalIdentityType.CustomerId,
      then: (schema) =>
        schema
          .required()
          .matches(/^[0-9]*$/, '${path} can contain only numbers')
          .min(8)
          .max(13),
    }),

  passportNumber: yup
    .string()
    .default('')
    .label('Passport number')
    .when('identityType', {
      is: PersonalIdentityType.PassportNumber,
      then: (schema) =>
        schema
          .required()
          .matches(/^[0-9a-zA-Z]*$/, '${path} can contain only letters and numbers')
          .min(5)
          .max(10),
    }),
});
